"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = exports.once = exports.sleep = void 0;
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
exports.sleep = sleep;
const once = (fn) => {
    let done = false;
    return function (...args) {
        return done ? void 0 : ((done = true), fn.apply(this, args));
    };
};
exports.once = once;
function debounce(func, waitMilliseconds = 50, options = {}) {
    var _a;
    let timeoutId;
    const isImmediate = (_a = options.isImmediate) !== null && _a !== void 0 ? _a : false;
    const maxWait = options.maxWait;
    let lastInvokeTime = Date.now();
    function nextInvokeTimeout() {
        if (maxWait !== undefined) {
            const timeSinceLastInvocation = Date.now() - lastInvokeTime;
            if (timeSinceLastInvocation + waitMilliseconds >= maxWait) {
                return maxWait - timeSinceLastInvocation;
            }
        }
        return waitMilliseconds;
    }
    const debouncedFunction = function (...args) {
        const context = this;
        const invokeFunction = function invokeFunction() {
            timeoutId = undefined;
            lastInvokeTime = Date.now();
            if (!isImmediate) {
                func.apply(context, args);
            }
        };
        const shouldCallNow = isImmediate && timeoutId === undefined;
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(invokeFunction, nextInvokeTimeout());
        if (shouldCallNow) {
            func.apply(context, args);
        }
    };
    debouncedFunction.cancel = function cancel() {
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
    };
    return debouncedFunction;
}
exports.debounce = debounce;
//# sourceMappingURL=data:application/json;base64,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